import { render, staticRenderFns } from "./TotalrecdetailbysellerReportDetail.vue?vue&type=template&id=bb0b7cfe"
import script from "./TotalrecdetailbysellerReportDetail.vue?vue&type=script&lang=js"
export * from "./TotalrecdetailbysellerReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports